export const italianProvinces = [
  { sigla: "AG", provincia: "Agrigento" },
  { sigla: "AL", provincia: "Alessandria" },
  { sigla: "AN", provincia: "Ancona" },
  { sigla: "AO", provincia: "Aosta" },
  { sigla: "AR", provincia: "Arezzo" },
  { sigla: "AP", provincia: "Ascoli Piceno" },
  { sigla: "AT", provincia: "Asti" },
  { sigla: "AV", provincia: "Avellino" },
  { sigla: "BA", provincia: "Bari" },
  { sigla: "BT", provincia: "Barletta-Andria-Trani" },
  { sigla: "BL", provincia: "Belluno" },
  { sigla: "BN", provincia: "Benevento" },
  { sigla: "BG", provincia: "Bergamo" },
  { sigla: "BI", provincia: "Biella" },
  { sigla: "BO", provincia: "Bologna" },
  { sigla: "BZ", provincia: "Bolzano" },
  { sigla: "BS", provincia: "Brescia" },
  { sigla: "BR", provincia: "Brindisi" },
  { sigla: "CA", provincia: "Cagliari" },
  { sigla: "CL", provincia: "Caltanissetta" },
  { sigla: "CB", provincia: "Campobasso" },
  { sigla: "CI", provincia: "Carbonia-Iglesias" },
  { sigla: "CE", provincia: "Caserta" },
  { sigla: "CT", provincia: "Catania" },
  { sigla: "CZ", provincia: "Catanzaro" },
  { sigla: "CH", provincia: "Chieti" },
  { sigla: "CO", provincia: "Como" },
  { sigla: "CS", provincia: "Cosenza" },
  { sigla: "CR", provincia: "Cremona" },
  { sigla: "KR", provincia: "Crotone" },
  { sigla: "CN", provincia: "Cuneo" },
  { sigla: "EN", provincia: "Enna" },
  { sigla: "FM", provincia: "Fermo" },
  { sigla: "FE", provincia: "Ferrara" },
  { sigla: "FI", provincia: "Firenze" },
  { sigla: "FG", provincia: "Foggia" },
  { sigla: "FC", provincia: "Forlì-Cesena" },
  { sigla: "FR", provincia: "Frosinone" },
  { sigla: "GE", provincia: "Genova" },
  { sigla: "GO", provincia: "Gorizia" },
  { sigla: "GR", provincia: "Grosseto" },
  { sigla: "IM", provincia: "Imperia" },
  { sigla: "IS", provincia: "Isernia" },
  { sigla: "SP", provincia: "La Spezia" },
  { sigla: "AQ", provincia: "L'Aquila" },
  { sigla: "LT", provincia: "Latina" },
  { sigla: "LE", provincia: "Lecce" },
  { sigla: "LC", provincia: "Lecco" },
  { sigla: "LI", provincia: "Livorno" },
  { sigla: "LO", provincia: "Lodi" },
  { sigla: "LU", provincia: "Lucca" },
  { sigla: "MC", provincia: "Macerata" },
  { sigla: "MN", provincia: "Mantova" },
  { sigla: "MS", provincia: "Massa-Carrara" },
  { sigla: "MT", provincia: "Matera" },
  { sigla: "ME", provincia: "Messina" },
  { sigla: "MI", provincia: "Milano" },
  { sigla: "MO", provincia: "Modena" },
  { sigla: "MB", provincia: "Monza e della Brianza" },
  { sigla: "NA", provincia: "Napoli" },
  { sigla: "NO", provincia: "Novara" },
  { sigla: "NU", provincia: "Nuoro" },
  { sigla: "OT", provincia: "Olbia-Tempio" },
  { sigla: "OR", provincia: "Oristano" },
  { sigla: "PD", provincia: "Padova" },
  { sigla: "PA", provincia: "Palermo" },
  { sigla: "PR", provincia: "Parma" },
  { sigla: "PV", provincia: "Pavia" },
  { sigla: "PG", provincia: "Perugia" },
  { sigla: "PU", provincia: "Pesaro e Urbino" },
  { sigla: "PE", provincia: "Pescara" },
  { sigla: "PC", provincia: "Piacenza" },
  { sigla: "PI", provincia: "Pisa" },
  { sigla: "PT", provincia: "Pistoia" },
  { sigla: "PN", provincia: "Pordenone" },
  { sigla: "PZ", provincia: "Potenza" },
  { sigla: "PO", provincia: "Prato" },
  { sigla: "RG", provincia: "Ragusa" },
  { sigla: "RA", provincia: "Ravenna" },
  { sigla: "RC", provincia: "Reggio di Calabria" },
  { sigla: "RE", provincia: "Reggio nell'Emilia" },
  { sigla: "RI", provincia: "Rieti" },
  { sigla: "RN", provincia: "Rimini" },
  { sigla: "RM", provincia: "Roma" },
  { sigla: "RO", provincia: "Rovigo" },
  { sigla: "SA", provincia: "Salerno" },
  { sigla: "VS", provincia: "Medio Campidano" },
  { sigla: "SS", provincia: "Sassari" },
  { sigla: "SV", provincia: "Savona" },
  { sigla: "SI", provincia: "Siena" },
  { sigla: "SR", provincia: "Siracusa" },
  { sigla: "SO", provincia: "Sondrio" },
  { sigla: "TA", provincia: "Taranto" },
  { sigla: "TE", provincia: "Teramo" },
  { sigla: "TR", provincia: "Terni" },
  { sigla: "TO", provincia: "Torino" },
  { sigla: "OG", provincia: "Ogliastra" },
  { sigla: "TP", provincia: "Trapani" },
  { sigla: "TN", provincia: "Trento" },
  { sigla: "TV", provincia: "Treviso" },
  { sigla: "TS", provincia: "Trieste" },
  { sigla: "UD", provincia: "Udine" },
  { sigla: "VA", provincia: "Varese" },
  { sigla: "VE", provincia: "Venezia" },
  { sigla: "VB", provincia: "Verbano-Cusio-Ossola" },
  { sigla: "VC", provincia: "Vercelli" },
  { sigla: "VR", provincia: "Verona" },
  { sigla: "VV", provincia: "Vibo Valentia" },
  { sigla: "VI", provincia: "Vicenza" },
  { sigla: "VT", provincia: "Viterbo" }
];

// For municipalities, we'll need to either:
// 1. Implement a backend proxy to the OpenAPI service
// 2. Use a simplified approach where users can type the municipality name
// 3. Load municipality data from a local file (would be large)

// For now, we'll implement a text input fallback for municipalities
export const fetchMunicipalitiesStub = async (provincia: string): Promise<{ comune: string }[]> => {
  // This is a stub that returns an empty array
  // In production, this should call your backend API
  console.warn(`Municipality API not implemented for province: ${provincia}`);
  return [];
};